import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class ConfigService {

    constructor() { }

    public get getAdalConfig(): any {
        return {
            tenant: '152aa3c2-ede6-44a7-b407-977fd5dd3df4',
            clientId: 'f7a576d3-6d3a-46d4-ba01-347d2b4f0144',
            redirectUri: window.location.origin + environment.oauthRedirectUri,
            postLogoutRedirectUri: window.location.origin + environment.oauthRedirectUri
        };
    }
} 



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/azure-authentication/config.service.ts